import React, {useContext, useState} from "react";
import {TranslateContext} from "../../../../context/TranslateContext";
import {AlertMsgContext} from "../../../../context/AlertMsgContext";
import {aggiornaDocumentoKpiApi} from "../../services/DocumentiServices";
import ModalDocumentoKpiView from "./ModalDocumentoKpiView";

export default function ModalDocumentoKpiController({
                                              idKpi,
                                              idTipoImport,
                                              show,
                                              handleClose,
                                              handleOk
                                          }) {

    const [files, setFiles] = useState([]);
    const [descrizione, setDescrizione] = useState('');
    const [idDocumento, setIdDocumento] = useState();

    const {translate} = useContext(TranslateContext);
    const {showErrorMessage} = useContext(AlertMsgContext);

    const url = process.env.REACT_APP_API_ENDPOINT + "/api/sost/kpi/" + idKpi + '/documento/';

    async function salvaDocumento() {
        let documento = {
            descrizione: descrizione,
            id_tipo_imp_dati: idTipoImport
        };
        let response = await aggiornaDocumentoKpiApi(idKpi, idDocumento, documento);
        if (response.data.result !== 0) {
            showErrorMessage(response.data.description);
        }
        return response.data.result === 0;
    }

    function handlePostDocumento(idDocumento) {
        setIdDocumento(idDocumento);
    }

    function handleDeleteDocumento() {
        setIdDocumento(null);
        setFiles([])
    }

    function onClickSalva() {
        let esito = salvaDocumento();
        if (esito) {
            handleOk();
        }
    }

    return (
        <ModalDocumentoKpiView
            show={show}
            handleClose={handleClose}
            idTipoImport={idTipoImport}
            translate={translate}
            descrizione={descrizione}
            setFiles={setFiles}
            files={files}
            idDocumento={idDocumento}
            url={url}
            setDescrizione={setDescrizione}
            handlePostDocumento={handlePostDocumento}
            handleDeleteDocumento={handleDeleteDocumento}
            onClickSalva={onClickSalva}
        />
    )
}